import { useState } from 'react';
import { Pressable } from 'react-native';
import { Link } from 'expo-router';

import { ThemedText } from '@/components/themed-text';
import { ThemedView } from '@/components/themed-view';
import { useAuth } from '@/hooks/use-auth';

function DevErrorTrigger() {
  const [shouldThrow, setShouldThrow] = useState(false);
  if (shouldThrow) {
    throw new Error('Dev error trigger: testing error boundary');
  }
  return (
    <Pressable
      onPress={() => setShouldThrow(true)}
      className="mt-4 rounded border border-red-500/30 px-6 py-3"
    >
      <ThemedText type="muted">Dev Throw Error</ThemedText>
    </Pressable>
  );
}

export default function ProfileScreen() {
  const { devSignOut } = useAuth();

  return (
    <ThemedView className="flex-1 items-center justify-center px-8">
      <ThemedText type="subtitle" className="mb-4">
        Profile
      </ThemedText>
      <ThemedText type="muted" className="mb-12 text-center">
        Account settings and preferences.
      </ThemedText>

      <Link href="/design">
        <ThemedText type="link">Design System {'\u2192'}</ThemedText>
      </Link>

      {__DEV__ && devSignOut && (
        <Pressable onPress={devSignOut} className="mt-12 rounded border border-gold/30 px-6 py-3">
          <ThemedText type="muted">Dev Sign Out</ThemedText>
        </Pressable>
      )}
      {__DEV__ && <DevErrorTrigger />}
    </ThemedView>
  );
}
